import config from 'config';
import getSystemUserAccessToken from 'helpers/getSystemUserAccessToken';
import url from 'helpers/url';
import queryString from 'query-string';
import SiteConfig from 'types/interfaces/SiteConfig';

interface FetchSiteConfig {
  token?: string;
  configOptions?: string[];
  host?: string;
}

const resolveSiteHost = (host?: string) => {
  const defaultHost = config.default_build_hosts?.[0];

  if (!host) {
    return defaultHost;
  }

  const hostnameOnly = host.split(':')[0];
  const isLocalHost = hostnameOnly === 'localhost' || hostnameOnly === '127.0.0.1';

  if (isLocalHost && defaultHost) {
    return defaultHost;
  }

  return host;
};

const fetchSiteConfig = async ({
  token,
  host,
  configOptions,
}: FetchSiteConfig = {}): Promise<SiteConfig> => {
  const resolvedHost = resolveSiteHost(host);

  if (!token) {
    const newToken = getSystemUserAccessToken(resolvedHost);

    token = newToken;
  }

  const includes = configOptions ? (configOptions?.length > 0 ? configOptions.join(',') : '') : '';
  const reqUrl = `${url}/store/configs`;
  const query: any = { host: resolvedHost };

  if (includes) {
    query.includes = includes;
  }

  const requestUrl = queryString.stringifyUrl({ url: reqUrl, query });

  const response: any = await fetch(requestUrl, {
    headers: {
      accessToken: token!,
    },
  });

  const rawResponse = await response.text();

  if (!response.ok) {
    throw new Error(
      `Failed to fetch site config (status ${response.status}) for host "${resolvedHost}"`,
    );
  }

  if (!rawResponse.trim()) {
    throw new Error(`Empty site config response for host "${resolvedHost}"`);
  }

  const configResponse = JSON.parse(rawResponse);

  return configResponse.configs;
};

export default fetchSiteConfig;
